export enum LOADING_STATUS {
  LOADING = 'loading',
  FAILED = 'failed',
  IDLE = 'idle',
}

export enum PERMISSIONS {
  UserRead = 'Permissions.User.Read',
  UserModify = 'Permissions.User.Modify',
  SettingRead = 'Permissions.Setting.Read',
  SettingModify = 'Permissions.Setting.Modify',
  BookingRead = 'Permissions.Booking.Read',
  BookingModify = 'Permissions.Booking.Modify',
  LocationRead = 'Permissions.Location.Read',
  LocationModify = 'Permissions.Location.Modify',
  AccommodationRead = 'Permissions.Accommodation.Read',
  AccommodationModify = 'Permissions.Accommodation.Modify',
  PricingRead = 'Permissions.Pricing.Read',
  PricingModify = 'Permissions.Pricing.Modify',
  FinancialRead = 'Permissions.Financial.Read',
  FinancialModify = 'Permissions.Financial.Modify',
  CustomerFeedbackRead = 'Permissions.CustomerFeedback.Read',
  CustomerFeedbackModify = 'Permissions.CustomerFeedback.Modify',
  TravelAgencyDomainUser = 'Permissions.TravelAgencyDomainUser',
}

export enum ROLES {
  Owner = 'Owner',
  Cleaner = 'Cleaner',
  TechnicalMaintainer = 'TechnicalMaintainer',
  KeyMaintainer = 'KeyMaintainer',
  LinenMaintainer = 'LinenMaintainer',
  Customer = 'Customer',
  TravelAgency = 'TravelAgency',
  TravelAgencyDomainUser = 'TravelAgencyDomainUser',
}

export enum CARETAKER_ROLES {
  Cleaner = '6D83090D-517C-4E17-922C-BCB8805AAE26',
  KeyMaintainer = '95EAFED4-7199-4F69-A856-E88C559CED8B',
  LinenMaintainer = 'FDF7339C-0D3B-428C-9B80-98AD599799AF',
  TechnicalMaintainer = 'C9ADBA8D-C014-4BCC-8B95-CCC3B302A407',
}

export enum OFFICER_ROLES {
  UserAdministrator = 'DC4E3221-FDBE-4F1D-BD68-01EA8DBD9DAA',
  AccommodationAdministrator = '1F643E37-6E19-44FA-9F84-14A9BD825D84',
  PaymentAdministrator = '1F643E37-6E19-44FA-9F84-14A9BD825D85',
  SettingAdministrator = '3B0166DA-B4FE-4047-8BFE-1C8550264089',
  BookingAdministrator = '0D7E4E1D-4287-426D-9FA3-44AB0BC5F2B8',
  FinancialManagementAdministrator = '23F03ACD-BC05-474D-B5D0-8A1DDD3C8931',
  LocationAdministrator = '59BB0E62-D0D7-415F-9801-8E0A949CAFF9',
  PricingAdministrator = 'B6C59240-E77A-4677-B7BD-D95D41E50E3D',
  CustomerFeedbackAdministrator = '77AA5CC8-C905-4EFF-B383-E33823E76546',
}

export enum CUSTOMER_ROLE {
  Customer = '259DCF7A-9512-4163-9D77-C44D97FDDCD1',
}

export enum OWNER_ROLE {
  Customer = '2257DF05-B62A-4DEA-B561-80F77595D188',
}

export enum TRAVELAGENCY_ROLE {
  Customer = '61BE6E51-2241-4674-BF7E-ABBAC8BBA433',
}

export enum CLAIM_TYPES {
  PermissionsType = 'permissions',
  RolesType = 'roles',
  SitesType = 'sites',
  ActiveSite = 'activeSite',
}

export enum LOCALES {
  Fi = 'fi_FI',
  En = 'en_EN',
}

export enum ORDER_DIRECTION {
  Asc = 'Ascending',
  Desc = 'Descending',
}

export enum SEASON_RATE_TYPE {
  Normal = 'Normal',
  Special = 'Special',
  OwnerDefined = 'OwnerDefined',
}

export enum BLOCKED_PERIOD_TYPE {
  OwnUse = 'Oma käyttö',
  Maintenance = 'Huolto',
  ICalImport = 'iCal import',
  Other = 'Muu',
}

export enum SEASON_RATE_RULE_TYPE {
  PreparationRestrictionRule = 'PreparationRestrictionRule',
  AdditionalServiceRule = 'AdditionalServiceRule',
  LastMinuteRateRule = 'LastMinuteRateRule',
  MinimumLengthOfStayRule = 'MinimumLengthOfStayRule',
  RateRuleReleaseInterval = 'RateRuleReleaseInterval',
  SeasonRatePriceChangeRule = 'SeasonRatePriceChangeRule',
  ShortStayRateRule = 'ShortStayRateRule',
  WeekdayCheckInAdditionalServiceRule = 'WeekdayCheckInAdditionalServiceRule',
  WeekdayCheckOutAdditionalServiceRule = 'WeekdayCheckOutAdditionalServiceRule',
  WeekdayCheckInRule = 'WeekdayCheckInRule',
  WeekdayCheckOutRule = 'WeekdayCheckOutRule',
  WeekdayCheckInTimeRateRule = 'WeekdayCheckInTimeRateRule',
  WeekdayCheckOutTimeRateRule = 'WeekdayCheckOutTimeRateRule',
  WeekdayMinimumStayRule = 'WeekdayMinimumStayRule',
  WeekdayPriceChangeRule = 'WeekdayPriceChangeRule',
  WeekdayPriceRateRule = 'WeekdayPriceRateRule',
}

export const WEEKDAYS_SHORT = [
  {
    weekdayInt: 1,
    weekdayString: 'Ma',
  },
  {
    weekdayInt: 2,
    weekdayString: 'Ti',
  },
  {
    weekdayInt: 3,
    weekdayString: 'Ke',
  },
  {
    weekdayInt: 4,
    weekdayString: 'To',
  },
  {
    weekdayInt: 5,
    weekdayString: 'Pe',
  },
  {
    weekdayInt: 6,
    weekdayString: 'La',
  },
  {
    weekdayInt: 0,
    weekdayString: 'Su',
  },
];

export const PRICE_CHANGE_TYPES = [
  {
    priceChangeType: 1,
    description: 'Kiinteä',
  },
  {
    priceChangeType: 2,
    description: 'Prosentuaalinen',
  },
];

export const SEASON_RATE_COLORS = [
  {
    id: '8E5DCA68-87E6-4102-873F-F2561D0CA012',
    name: 'Vihreä',
  },
  {
    id: 'A0BAFA15-EF19-4A90-AAE2-E3E505C3763F',
    name: 'Punainen',
  },
  {
    id: 'CAD1BA9D-F2BE-4D83-B0BB-C5116504E0E6',
    name: 'Sininen',
  },
  {
    id: '223A4061-8CD7-4F5A-BD9E-23DE84120E11',
    name: 'Keltainen',
  },
];

export enum SEASON_RATE_BATCH_OPERATION_TYPE {
  SeasonRateCopying = 'SeasonRateCopying',
  PriceChange = 'PriceChange',
  AdditionalServiceRules = 'AdditionalServiceRules',
  DateChange = 'DateChange',
  SeasonRateCopyingRevert = 'SeasonRateCopyingRevert',
  DateChangeRevert = 'DateChangeRevert',
  Other = 'Other',
}

export const SEASON_RATE_BATCH_OPERATION_TYPE_DESCRIPTIONS = {
  [SEASON_RATE_BATCH_OPERATION_TYPE.SeasonRateCopying]:
    'Hintakausien kopiointi',
  [SEASON_RATE_BATCH_OPERATION_TYPE.PriceChange]: 'Hintojen muutos',
  [SEASON_RATE_BATCH_OPERATION_TYPE.AdditionalServiceRules]:
    'Lisäpalvelusääntöjen muutos',
  [SEASON_RATE_BATCH_OPERATION_TYPE.DateChange]: 'Päivämäärien muutos',
  [SEASON_RATE_BATCH_OPERATION_TYPE.SeasonRateCopyingRevert]:
    'Hintakausien kopioinnin palautus',
  [SEASON_RATE_BATCH_OPERATION_TYPE.DateChangeRevert]:
    'Päivämäärien muutoksen palautus',
  [SEASON_RATE_BATCH_OPERATION_TYPE.Other]: 'Muu',
};

export const TOAST_SHOW_DURATION = 5000;
